import { Link } from "react-router-dom";
import { Badge } from "@volca/ui/components/ui/badge";
import { Card } from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { profitabilityTemplatePath } from "./routes";
import { templateStatus } from "./template-status";
import type { ProfitabilityReport } from "./types";

export const TemplateCard = ({ report }: { report: ProfitabilityReport }) => {
  const status = templateStatus(report);
  // Its page opens on Setup while it is being set up, on Review once it runs.
  return (
    <Link
      to={profitabilityTemplatePath(report.id)}
      className="group min-w-0 rounded-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      data-testid="report-card"
    >
      <Card className="flex h-full min-w-0 flex-col gap-6 border-line p-6 shadow-none transition-colors group-hover:bg-neutral-hovered">
        <Stack direction="row" align="center" justify="between" gap={2}>
          <Text
            render={<h3 />}
            variant="heading"
            className="min-w-0 [overflow-wrap:anywhere]"
          >
            {report.name}
          </Text>
          <Badge variant="secondary" color={status.color} size="sm">
            {status.label}
          </Badge>
        </Stack>
        {report.description && (
          // The full description lives on the template's Description tab. Here it
          // only identifies the template, so a long one can't stretch its row,
          // and its line breaks run together rather than spend those four lines.
          <Text variant="body" tone="muted" className="line-clamp-4">
            {report.description}
          </Text>
        )}
        {report.inputs.length > 0 && (
          <Text tone="muted">
            Reads {report.inputs.map((slot) => slot.title).join(", ")}
          </Text>
        )}
      </Card>
    </Link>
  );
};
